const trustItems = [
  { icon: "ri-map-pin-2-line", label: "Toronto-Based Contractor" },
  { icon: "ri-building-2-line", label: "Commercial & Institutional" },
  { icon: "ri-draft-line", label: "Design/Build Capability" },
  { icon: "ri-time-line", label: "Reliable Project Delivery" },
];

export default function TrustBar() {
  return (
    <section className="w-full bg-stone-900 border-b border-stone-800">
      <div className="w-full px-6 lg:px-12">
        <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-between py-5 gap-4 sm:gap-0 max-w-5xl mx-auto">
          {trustItems.map((item, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-stone-400 text-base`}></i>
              </div>
              <span
                className="text-stone-300 text-xs uppercase tracking-[0.16em] font-medium whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {item.label}
              </span>
              {idx < trustItems.length - 1 && (
                <div className="hidden sm:block w-px h-5 bg-stone-700 ml-4" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
